import { create } from 'apisauce';

export const getLinkedLogins = async () => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/account/linked_logins`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'x-Requested-with': 'XMLHttpRequest',
    },
  });

  const response = await api.get();
  return response;

};

export const deleteLinkedLogins = async (id) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/account/linked_logins/${id}/delete`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'x-Requested-with': 'XMLHttpRequest',
    },
  });

  const response = await api.delete();
  return response;

};

export const createLinkedLogins = async (username, password) => {

  if (!username || !password) {
    return { error: 'Missing value', value: { username: !username, password: !password } };
  }

  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/account/linked_logins`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  const response = await api.post('', { username, password });
  return response;
};

export const resetPassword = async (username) => {
  if (!username) {
    return { error: 'Missing value', value: { username: !username } };
  }

  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/account/password/reset`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  const response = await api.post('', { username, organization: null });
  return response;
};

export const getSeats = async (orgId) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/${orgId}/integrations/ny-email-calendar`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.get('');
};

export const updateSeats = async(orgId, data) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/${orgId}/integrations/ny-email-calendar`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.post('', data);
};

export const getMembers = async (orgId) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/${orgId}/members`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.get('');
};

export const getMemberIntegrations = async (orgId) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/${orgId}/integrations`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.get('');
};

export const getSeatsBillingData = async (orgId, seatsCount) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/${orgId}/integrations/cost-preview`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.get('', { 'seats-count': seatsCount });
};
